<script>
import { mapActions } from 'vuex';
import i18n from '@/plugins/i18n';

export default {
    props: {
        selectedCompanyId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            description: null,
            fallbackValue: null,
        }
    },

    computed: {
        descriptionColor() {
            if (!this.description) return 'var(--invalid-input)';

            if (this.description.length < 250 || this.description.length > 5000) {
                return 'var(--invalid-input)';
            } else if (this.description.length >= 250 && this.description.length < 1000) {
                return 'var(--sustainfinity-blue)';
            } else {
                return 'var(--sustainfinity-green)';
            }
        }
    },

    watch: {
        description(newVal, oldVal) {
            if (newVal == null) newVal = '';
            if (oldVal == null) oldVal = '';

            if (newVal.length >= oldVal.length) {
                const el = window.document.getElementById('textArea');
                if (el) {
                    if (el.clientHeight < el.scrollHeight) {
                        el.style.height = `${10 + el.scrollHeight}px`;
                    }
                } else {
                    el.style.height = '100px';
                }
            }

            if (newVal.includes('  ')) {
                this.description = newVal.replace('  ', ' ');
            }
        }
    },

    mounted() {
        this._getAboutCompany();
    },

    methods: {
        ...mapActions('company', [
            'getAboutCompany',
            'updateCompany',
        ]),

        _getAboutCompany() {
            this.getAboutCompany()
                .then(res => {
                    this.description = res.data.description != null && res.data.description != undefined ? res.data.description : '';
                })
                .finally(() => {
                    const el = window.document.getElementById('textArea');
                    if (el) {
                        if (el.clientHeight < el.scrollHeight) {
                            el.style.height = `${10 + el.scrollHeight}px`;
                        }
                    } else {
                        el.style.height = '100px';
                    }
                })
        },

        _updateCompany() {
            if (this.description.length < 250 || this.description.length > 5000) {
                this.$notify('error', i18n.t('companyProfile.field_not_in_range'), true);
                return;
            }

            const params = {
                company_id: this.selectedCompanyId,
                body: {
                    description: this.description
                }
            }

            this.updateCompany(params)
                .then(res => {
                    this.setFallbackValue(null);
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.description = this.fallbackValue;
                    this.$notify('error', response.data.messageName);
                })
        },

        setFallbackValue(val) {
            this.fallbackValue = val;
        },
    }
}
</script>

<template>
    <div class="about-the-company">
        <textarea id="textArea" rows="4" v-model="description" @change="_updateCompany()"
            @focus="setFallbackValue(description)" @blur="setFallbackValue(null)"
            maxlength="5000"
            :style="{'outline-color': descriptionColor}"
        ></textarea>

        <div v-if="fallbackValue != null" :style="{'color': descriptionColor}">
            {{ $t('companyProfile.editing') }}: {{ description.length }}/5000 ({{ $t('companyProfile.validations.min_250') }}) 
        </div>
    </div>
</template>

<style lang='scss' scoped>
.about-the-company {
    width: 100%;
    height: fit-content;
}

textarea {
    min-height: 100px !important;
    width: 100%;
    padding: .5em;
    border-radius: .25em;
    border: 0 !important;
    outline-width: 0;

    background-color: whitesmoke;

    &:focus {
        outline-style: solid;
        outline-width: .125em;
        background-color: rgb(234, 234, 234);
    }
}
</style>